export default __webpack_public_path__ + "static/media/523.b44a9147.gif";